/* istanbul ignore file */
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { OPPORTUNITY_STAGES } from 'domain/sales/opportunity/opportunityService';

const OpportunityStageDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={OPPORTUNITY_STAGES} />;
};

export default OpportunityStageDropdown;
